<template>
<div class="transfer-view">
    <div class="content">
      <div class="top">
        <div class="title">{{$t("转移所有权#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}</div>
        <div class="close-btn" @click.stop="handleClose">
          <svg-icon icon-class="file-transfer-close" class="close-icon"></svg-icon>
        </div>
      </div>
      <div class="center" :style="hasChild ? 'padding-bottom: 24px' : ''">
        <div class="title">{{$t("转移给：#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}</div>
        <div class="member-input" ref="inputContainer" @mouseenter="hoverInput(true)" @mouseleave="hoverInput(false)">
          <MemberTag v-if="selectedMember" :data="selectedMember" @deleteMember="deleteMember"></MemberTag>
          <SearchMember v-show="!selectedMember" :searchText="searchText" @selectMember="selectMember">
            <div ref="searchInput" slot="reference" class="search-input" contenteditable="true" @input="searchMembers" @focus="searchInputFocus" @blur="handleBlur" @keydown="handleKeyDown">
              <div id="search-placeholder">{{$t("输入用户姓名查找#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}</div>
            </div>
          </SearchMember>
          <div v-show="searchText" class="clear-btn" @click.stop="clearText">
            <svg-icon icon-class="file-transfer-input-clear" class="clear-icon"></svg-icon>
          </div>
        </div>
        <div v-if="hasChild" class="options">
          <moo-checkbox class="file-transfer-options-checkbox" v-model="transferChild"></moo-checkbox>
          <span class="options-span">{{$t("同时转移该文件夹下属于我的子文件夹、文档#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}</span>
        </div>
      </div>
      <div class="bottom">
        <div class="btn cancel" @click.stop="handleClose">{{$t("取消#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}</div>
        <div class="btn confirm" :class="{ disabled: !selectedMember }" @click.stop="handleTransfer">{{$t("转移#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}        </div>
      </div>

      <moo-dialog top="25vh" width="529px" custom-class="cloud-common-dialog" :show-close="false" :visible.sync="confirmDialogVisible" append-to-body="">
        <div class="title">
          <svg-icon class-name="dialog-icon" icon-class="file-warning"></svg-icon>{{$t("提示#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}        </div>
        <div class="content">{{$t("转移后你将不再是此文档的所有者，是否将所有权转移给#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}          {{selectedMember?.memberName}} ？        </div>
        <div class="footer">
          <div class="custom-button link-button" @click.stop="confirmDialogVisible = false">{{$t("取消#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_2")}}          </div>
          <div class="custom-button reconnect-button" @click.stop="confirmToTransfer">{{$t("确认#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1")}}          </div>
        </div>
      </moo-dialog>
    </div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import SearchMember from "./searchMember.vue";
import MemberTag from "./memberTag.vue";
import { transferFileOwner } from "@/api/h5/file";

export default {
  name: "TransferView",
  components: {
    SearchMember,
    MemberTag
  },
  props: {
    fileId: {
      type: String
    },
    typeInfo: {
      type: Object
    }
  },
  data() {
    return {
      transferChild: false,
      confirmDialogVisible: false,
      searchText: "",
      isFocus: false,
      selectedMember: null
    };
  },
  computed: {
    hasChild() {
      return (
        this.typeInfo.type === "FOLDER" ||
        this.typeInfo.productType === "WIKI_FILE");

    }
  },
  watch: {},
  methods: {
    handleClose() {
      this.$emit("closeTransferDialog");
    },
    handleTransfer() {
      if (!this.selectedMember) {
        return;
      }
      this.confirmDialogVisible = true;
    },
    confirmToTransfer() {
      const data = {
        spaceId: this.selectedMember.spaceId,
        userId: this.selectedMember.userId,
        transferChild: this.transferChild
      };
      transferFileOwner(this.fileId, data).
      then((res) => {
        if (res.code === 200) {
          this.confirmDialogVisible = false;
          this.handleClose();
          if (!res.data?.transferChild) {
            this.$message.success(intl.$t("转移所有权成功#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1"));
          }
        } else {
          this.$message.error(intl.$t(`转移所有权失败#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1`));
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("转移所有权失败，请重新尝试#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_1"));
      });
    },
    searchMembers(event) {
      this.searchText = event.target.innerText;
      this.handleRemovePlaceholder();
    },
    searchInputFocus() {
      this.handleRemovePlaceholder();
      this.isFocus = true;
      this.inputContainerBorderStyle(true);
      this.handleRange();
    },
    handleRange() {
      const input = this.$refs.searchInput;
      const range = document.createRange();
      const sel = window.getSelection();
      range.setStart(input, 0);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 300);
    },
    handleBlur() {
      this.isFocus = false;
      if (this.searchText) {
        this.$refs.inputContainer.style.background = "#FFFFFF";
      } else {
        this.handleAddPlaceholder();
        this.inputContainerBorderStyle(false);
      }
    },
    handleKeyDown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },
    clearText() {
      this.$refs.searchInput.innerText = this.searchText = "";
      this.$refs.searchInput.focus();
    },
    hoverInput(isHover) {
      if (this.selectedMember) {
        return;
      }
      if (isHover) {
        this.inputContainerBorderStyle(true);
      } else {
        if (!this.isFocus) {
          this.inputContainerBorderStyle(false);
        }
      }
    },
    inputContainerBorderStyle(hasBorder) {
      if (hasBorder) {
        this.$refs.inputContainer.style.border = "1px solid #5C70FF";
        this.$refs.inputContainer.style.background = "#FFFFFF";
      } else {
        this.$refs.inputContainer.style.border = "1px solid #F5F6F7";
        this.$refs.inputContainer.style.background = "#F5F6F7";
      }
    },
    handleAddPlaceholder() {
      const placeholder = document.createElement("div");
      placeholder.id = "search-placeholder";
      placeholder.innerText = intl.$t("输入用户姓名查找#!!!#src/pages/H5/Cloud/components/transfer/TransferView.vue_2");
      this.$refs.searchInput.appendChild(placeholder);
    },
    handleRemovePlaceholder() {
      let t = this.$refs.searchInput.querySelector("#search-placeholder");
      if (!!t) {
        t.remove();
      }
    },
    selectMember(item) {
      this.$refs.searchInput.innerText = this.searchText = "";
      this.selectedMember = item;
      this.inputContainerBorderStyle(false);
    },
    deleteMember(item) {
      this.selectedMember = null;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.transfer-view {
  width: 100%;
  position: relative;

  .content {
    height: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .top {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .title {
        font-family: "PingFang SC", sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #000000d9;
        line-height: 24px;
      }

      .close-btn {
        width: 24px;
        height: 24px;
        cursor: pointer;

        .close-icon {
          padding: 6px;
          width: 12px;
          height: 12px;
        }

        &:hover {
          background: #f4f6f9;
          border-radius: 4px;
        }
      }
    }

    .center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      padding: 24px 0 40px 0;

      .title {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #121317d9;
        line-height: 24px;
        margin-bottom: 8px;
      }

      .member-input {
        width: 100%;
        height: 32px;
        background: #f5f6f7;
        border-radius: 6px;
        border: 1px solid #f5f6f7;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        .search-input {
          display: inline-flex;
          flex: 1;
          padding: 6px 12px;
          background: transparent;
          border: none;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #121317;
          text-align: left;

          &:focus-visible {
            outline: none;
          }
        }

        .search-input-placeholder {
          display: inline-block;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #a2a4b0;
          line-height: 20px;
          cursor: text;
        }

        .clear-btn {
          width: 16px;
          height: 16px;
          padding-right: 12px;
          cursor: pointer;

          .clear-icon {
            width: 16px;
            height: 16px;
          }
        }
      }

      .options {
        margin-top: 8px;

        .options-span {
          margin-left: 8px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #646a73;
          line-height: 20px;
        }
      }
    }

    .bottom {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;

      .btn {
        width: 88px;
        height: 36px;
        border-radius: 6px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
        line-height: 36px;
        margin-left: 16px;
        cursor: pointer;

        &.cancel {
          color: #222329;
          background: #ffffff;
          border: 1px solid #e8e9ee;

          &:hover {
            background: #f4f6f9;
          }
        }

        &.confirm {
          color: #ffffff;
          background: #5c70ff;

          &:hover {
            background: #6d7dff;
          }

          &.disabled {
            background: #ced4ff;
            border-radius: 6px;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  #search-placeholder {
    display: inline-block;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #a2a4b0;
    line-height: 20px;
    cursor: text;
  }
}
</style>

<style lang="scss">
@import "~@/styles/cloudCommonDialog.scss";

.file-transfer-options-checkbox {
  width: 16px;
  height: 16px;

  .moo-checkbox__input.is-checked {
    .moo-checkbox__inner {
      border-color: #5c70ff;
      background-color: #5c70ff;
    }
  }

  .moo-checkbox__input.is-focus {
    .moo-checkbox__inner {
      border-color: #5c70ff;
    }
  }

  .moo-checkbox__inner {
    width: 16px;
    height: 16px;

    &:hover {
      border-color: #5c70ff;
    }
  }

  .moo-checkbox__inner::after {
    top: 2px;
    left: 5px;
  }
}
</style>
